export enum SeparatorIdentifier {
    ON_DARK = 'on-dark',
    ON_LIGHT = 'on-light',
    GROUP_ON_LIGHT = 'group-on-light',
}
